module.exports = __webpack_public_path__ + "img/action.f99776fb.svg";